


















































































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import * as avidia from "@/shared/avidiaUrls";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {}
})
export default class AvidiaForms extends Vue {
  AvidiaUrls = avidia;

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
